import { render, staticRenderFns } from "./SimplePrintTable.vue?vue&type=template&id=55769564&scoped=true&"
import script from "./SimplePrintTable.vue?vue&type=script&lang=js&"
export * from "./SimplePrintTable.vue?vue&type=script&lang=js&"
import style0 from "./SimplePrintTable.vue?vue&type=style&index=0&id=55769564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55769564",
  null
  
)

export default component.exports